export default [{
    path: '/chemicals',
    component: ()=> import("@/views/Chemicals"),
    meta:{
        title:"中国药典"
    },
    children:[]
},
{
    path: '/chemicalsDetail',
    component: ()=> import("@/views/ChemicalsDetail"),
    meta:{
        title:"中国药典详情"
    },
    children:[]
}
]